module.exports = __webpack_public_path__ + "img/icon-vaccine-menu-covid.3cc155fa.svg";